<template>
    <p style="font-size: 14px; font-weight: 500; background-color: #f5eeed;" class="text-center justify-center py-3 mb-0 px-3">Discover cultural events, businesses, artists, organizations, makers, and experiences - all in one place.</p>
        <AppShowcase />
        <HeroSlider @scroll-to="handleScroll"/>
        <!-- <section class="pt-0 pb-0 banner-ser l-primary-bg">
            <div class="container">
                <div class="row">
                    <div class=" banner-ser-col d-flex justify-content-center flex-wrap gap-4 banner-ser-item">
                        <article class="event-category-article bg-white p-4" v-for="(eventType,index) in eventTypes" :key="index">
                            <router-link
                            :to="{
                                name: ROUTES.CATEGORY_EVENT_INFO,
                                params: {
                                category: eventType.name,
                                },
                            }"
                            target="_blank"
                            >
                                 <span v-bind:class="eventType.media ? 'real-image' : ''" class="ser-icon"> <img :src="(!eventType.media && !eventType.media) ? bannerSer01 : MEDIA_BASEURL+eventType.media" alt="img"></span> 
                                <span class="ser-content d-hex-color">{{ eventType.name }}</span>
                            </router-link>
                        </article>
                    </div>
                </div>
            </div>
        </section> -->


        <!-- Cultural Spotlights -->
        <div class="container spotlight-section pt-5">
            <div class="row">
                <div class="call-us-box-content text-center justify-center">
                    <h2 class="d-hex-color fw-semibold">Cultural Spotlights</h2>
                    <p style="color: gray;" class="mt-4">
                        Highlighting everyday culture through extraordinary stories.
                    </p>
                </div>
            </div>
        </div>

        <div class="container">
            <Carousel
                :items-to-show="itemsToShow"
                :items-to-scroll="1"
                :breakpoints="breakpoints"
                :wrap-around="false"
                navigationEnabled
            >
                <Slide v-for="(cultural, index) in culturalSpotlights" :key="index">
                    <div class="slide-content card mx-2 cursor-pointer">
                        <div @click="detail(`${cultural.title}`, cultural?._id, 'cultural')">
                            <img
                                :src="`${MEDIA_BASEURL}${cultural.banner}`"
                                class="card-img"
                                alt="Cultural Spotlights"
                            />
                        </div>
                        <div class="card-overlay text-white p-3">
                            <h3 class="card-title m-0">{{ cultural.title }}</h3>
                            <p class="card-text small mt-2">{{ truncateDescription(cultural.subTitle) }}</p>
                        </div>
                    </div>
                </Slide>
                <template #addons>
                    <Navigation />
                </template>
            </Carousel>
            <div class="mb-5 d-flex justify-content-center align-items-center gap-3 mt-4">
                <p class="d-hex-color">Have a story to share?</p>
               <router-link
                    :to="{ name: ROUTES.SHARE_STORY }"
                    class="primary-bg text-white pt-2 pb-2 ps-4 pe-4 d-flex rounded"
                    @click="trackShareStory"
                    >
                    Tell Us Here <i class="fa fa-arrow-right ms-2" aria-hidden="true"></i>
                </router-link>
            </div>
        </div>


       <!-- Meet the Makers of Culture -->
        <div class="container culture-section pt-5">
             <div class="row justify-content-center">
                <div class="call-us-box-content text-center">
                    <h2 class="d-hex-color fw-semibold">Meet the Makers of Culture</h2>
                    <p style="color: gray;" class="mt-4">Get to know the artists, builders, thinkers, and doers shaping the cultural landscape.</p>
                </div>
            </div>
        </div>

        <div class="container mb-4 pb-4">
            <Carousel
                :items-to-show=itemsToShow
                :items-to-scroll="1"
                :breakpoints="breakpoints"
                :wrap-around="false"
                navigationEnabled
            >
                <Slide v-for="(maker, index) in makers" :key="index" v-bind="config">
                    <div class="mx-2 cursor-pointer">
                        <!-- Image Section -->
                        <div @click="detail(`${maker.title}`, maker?._id, 'maker')">
                            <img 
                            :src="`${MEDIA_BASEURL}${maker.banner}`" 
                            alt="maker" 
                            class="w-100" 
                            style="height: 390px; object-fit: cover;" 
                            />
                            
                        </div>

                        <!-- Text Section -->
                        <div class="py-3 text-start">
                            <h3 class="card-title m-0 " >{{ maker.title }}</h3>
                            <p class="card-text small mt-2 ">{{ truncateDescription(maker.subTitle) }}</p>
                        </div>
                    </div>
                </Slide>
                <template #addons>
                    <Navigation />
                </template>
            </Carousel>
            <div class="d-flex justify-content-center align-items-center gap-3 mb-4 pb-4">
                <p class="d-hex-color">Want to nominate a maker?</p>
                <a href="#" @click="openNominateMakerModal" class="primary-bg text-white pt-2 pb-2 ps-4 pe-4 d-flex rounded">Nominate Maker<i class="fa fa-arrow-right ms-2" aria-hidden="true"></i></a>
            </div>
        </div>

        <section v-bind:class="!haveSpecialEvent ? 'pb-5 pt-2 l-primary-bg' : 'l-primary-bg'" v-if="!haveSpecialEvent">

        </section>


        <!-- <events-list  v-if="popularEventDetails.initialResponse" :filter-type="eventFilterTypes.popular" :event-list-type="EVENTS_LIST.POPULAR"  @handle-filter-type-change="handleFilterTypeChange" :custom-class="(latitude && nearbyEvents?.length > 0 )? 'bg-site__light__peach' : ''" :events-list="popularEventDetails.popularEvents" :title="popularEventDetails.isLocationEvent ? 'Popular Events in '+aplace : 'Popular Events'" :see-all-route="{name:ROUTES.BROWSE_EVENTS_LIST,params:{eventListType:EVENTS_LIST.POPULAR}}"/> -->
  
        <events-list
            v-if="isFeatureEventSectionVisible && featuredEvents.length > 0"
            :filter-type="eventFilterTypes.featured"
            :event-list-type="EVENTS_LIST.FEATURED"
            @handle-filter-type-change="handleFilterTypeChange" 
            custom-class="bg-site__light__peach" 
            :events-list="featuredEvents" 
            is-featured="true" 
            title="Featured Events" 
            :see-all-route="{name:ROUTES.BROWSE_EVENTS_LIST,params:{eventListType:EVENTS_LIST.FEATURED}}"
            ref="featured"
        />
      
        <!-- <events-list 
            v-if="upcomingEventDetails.initialResponse"   
            :filter-type="eventFilterTypes.upcoming"
            :event-list-type="EVENTS_LIST.UPCOMING"
            @handle-filter-type-change="handleFilterTypeChange" 
            :custom-class="!(latitude && nearbyEvents?.length > 0) ? 'bg-site__light__peach' : ''" 
            :events-list="upcomingEventDetails.upcomingEvents" 
            :title="upcomingEventDetails.isLocationEvent ? 'Upcoming Events in '+aplace : 'Upcoming Events' " 
            :see-all-route="{name:ROUTES.BROWSE_EVENTS_LIST,params:{eventListType:EVENTS_LIST.UPCOMING}}"
            ref="upcomingEvent"
        /> -->


        <!-- <events-list v-if="(latitude  && nearbyEvents?.length > 0)"  :filter-type="eventFilterTypes.nearby" :event-list-type="EVENTS_LIST.NEARBY" @handle-filter-type-change="handleFilterTypeChange" :events-list="nearbyEventsList" :title="'Event Near in '+aplace" :see-all-route="{name:ROUTES.BROWSE_EVENTS_LIST,params:{eventListType:'nearby'}}"/>
        <events-list v-if="favEvents?.length > 0 && user"         :filter-type="eventFilterTypes.favourites" :event-list-type="EVENTS_LIST.FAVOURITES" @handle-filter-type-change="handleFilterTypeChange" custom-class="bg-site__light__peach" :backButton="false" :events-list="favEventsList" title="Favourite Events" :see-all-route="{name:ROUTES.BROWSE_EVENTS_LIST,params:{eventListType:'favorites'}}"/>
        <events-list v-if="ComneteEvents?.length > 0" :custom-class="(latitude && nearbyEvents?.length > 0 )? 'bg-site__light__peach' : ''" :events-list="ComneteEvents" title="Popular Planner Events" :see-all-route="{name:ROUTES.BROWSE_EVENTS_LIST,params:{eventListType:EVENTS_LIST.COMNETE}}"/> -->

        
        <!-- <culture-slider :limit="6" /> -->

        <!-- Organizations -->
        <!-- <section v-if="organizationDetails.organizations.length > 0" class="category-article-section l-primary-bg pt-0 bg-site__light__peach">
            <div class="container">
                <div class="row ms-2 me-2">
                    <div class="page-title-cover d-flex justify-content-between align-items-center">
                        <div class="page-title">
                            <h3 class="fw-semibold" 
                            >Organizations in {{ aplace }}</h3>
                            <h3 class="fw-semibold" v-if="!organizationDetails.isLocationOrganization">{{ organizationDetails.organizations.length > 1 ? 'Organizations' : 'Organization' }}</h3>
                        </div>
                        <div class="g-btn">
                            <a href="/events/featured" class="primary-bg text-white pt-2 pb-2 ps-4 pe-4 d-flex">View All <i class="fa fa-arrow-right" aria-hidden="true"></i></a>
                        </div>
                    </div>
                    <div class="row ms-2 mt-5 me-2">
                        <div class="organizers-col d-flex flex-wrap  gap-4">
                            <organizer-event-count-card v-for="(organization, index) in organizationDetails.organizations" :key="index" :organizer="organization" :show-event-count="false"/>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->

        <!-- Organizers -->
        <!-- <section v-if="organizerDetails.organizers.length > 0" class="category-article-section l-primary-bg pt-0 bg-site__light__peach">
            <div class="container">
                <div class="row ms-2 me-2">
                    <div class="page-title-cover d-flex justify-content-between align-items-center">
                        <div class="page-title">
                            <h3 class="fw-semibold" v-if="organizerDetails.isLocationOrganizer">Organizers in {{ aplace }}</h3>
                            <h3 class="fw-semibold" v-if="!organizerDetails.isLocationOrganizer">Popular Organizers</h3>
                        </div>
                       
                    </div>
                    <div class="row ms-2 mt-5 me-2">
                        <div class="organizers-col d-flex flex-wrap  gap-4">
                            <organizer-event-count-card v-for="(organizer, index) in organizerDetails.organizers" :key="index" :organizer="organizer" :show-event-count="false"/>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->

        <!-- Orange Section -->
        <section class="call-us-box-ser primary-bg overlay-before overlay-after circle-shap position-relative overflow-hidden">
            <div class="container">
                <div class="row">
                    <div class="call-us-box-content text-center">
                        <h2 class="text-white fw-semibold">Travel the World in the City</h2>
                    <p class="text-white mt-3 mb-4"> Find events and organizations by searching on this site</p>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="justify-content-center d-flex gap-5 flex-wrap">
                        <article class="">
                            <span class="ser-icon bg-white p-4"> <img :src="callusser_starSolid" alt="img"></span>
                            <span class="ser-content text-white text-center">Find Cultural Events</span>
                        </article>
                        <article class="">
                            <span class="ser-icon bg-white p-4"> <img :src="callusser_phoneFill" alt="img"></span>
                            <span class="ser-content text-white text-center">Explore new Cultures</span>
                        </article>
                        <article class="">
                            <span class="ser-icon bg-white p-4"> <img :src="callusser_bxsMap" alt="img"></span>
                            <span class="ser-content text-white text-center">Discover Hidden Gems in your city</span>
                        </article>
                        <article class="">
                            <span class="ser-icon bg-white p-4"> <img :src="callusser_ionHappy" alt="img"></span>
                            <span class="ser-content text-white text-center">Meet like minded people</span>
                        </article>
                    </div>
                </div>
            </div>
        </section>

        <!-- Uncover the worldwide events -->
        <!-- <section v-if="eventCities.length > 0" class="category-article-section l-primary-bg  country-section-col">
            <div class="container">
                    <div class="row ms-2 me-2">
                        <div class="page-title-cover d-flex justify-content-between align-items-center">
                            <div class="page-title">
                                <h3 class="fw-semibold">Uncover Worldwide Events</h3>
                            </div>
                        </div>
                    </div>
                    <div class="row ms-2 me-2 mt-3 pt-3">
                    <div class="article-col d-flex gap-3 flex-wrap">
                        <article v-for="(cityVal,index) in eventCities" :key="index" @click="$router.push({name:ROUTES.CITY_EVENTS_INFO,params:{cityName:cityVal.city}})" class="cursor-pointer info-box position-relative overflow-hidden overlay-before">                               
                                <span class="info-box-img position-relative overflow-hidden">
                                    <img :src="cityVal.imageUrl" alt="img">
                                </span>
                                <span class="info-box-content">
                                    <span class="info-box-title text-white">
                                        {{ cityVal.city }}
                                    </span>
                                </span>                               
                        </article>
                    </div>
                </div>
            </div>
        </section> -->
        <!-- <events-list  
            :class="eventCities.length == 0 ? 'pt-5' : ''"  
            :show-extra-option="false"  
            :filter-type="eventFilterTypes.worldwidePopular" 
            :event-list-type="eventFilterTypes.worldwidePopular"  
            @handle-filter-type-change="handleFilterTypeChange" 
            :custom-class="(latitude && nearbyEvents?.length > 0 )? 'bg-site__light__peach' : ''" 
            :events-list="worldwidePopularEvents" title="World wide Popular events" 
            :see-all-route="{name:ROUTES.BROWSE_EVENTS_LIST,params:{eventListType:EVENTS_LIST.POPULAR}}"
            ref="mostPopular"
        /> -->
         
        <solution-for-creator />

        <testimonial />
        <private-event-footer/>
        
        <section class="call-us-one-section footer-call-us l-primary-bg overflow-hidden pb-0">
            <div class="container">
                <div class="row ms-2 me-2">
                    <!-- <div class="call-us-box d-flex align-items-center justify-content-between position-relative primary-bg overlay-before overlay-after circle-shap position-relative 
                    ">
                        <div class="call-us-box-content">
                            <h2 class="text-white fw-semibold">Download The App</h2>
                        <p class="text-white mt-3 mb-4">
                            Download the app to track the events and organizations while you’re on the go. Access and book tickets, and also post your events.
                        </p>
                        <div class="g-btn d-flex">
                            <span>
                                <a rel="nofollow" target="_blank" href="https://play.google.com/store/apps/details?id=com.culturecity.app">
                                    <img :src="googleApp" alt="img">
                                </a>
                            </span>
                            <span>
                                <a rel="nofollow" target="_blank" href="https://apps.apple.com/app/id1606290365">
                                    <img :src="appStore" alt="img">
                                </a>
                            </span>
                        </div>
                        </div>
                        <div class="call-us-one-img">
                            <img :src="footerCallUs01" alt="img">
                            </div>
                    </div> -->
                </div>
            </div>
        </section>

        <message-modal :modal-active="isSuccessMessageModal" :toggle-modal="onSuccessMessageModal" title="Ticket Booking successful">
            <div>
            <p class="mb-2.5 font-semibold text-heading__color text-center">
                Congratulations <br/>
                Your tickets are sent to your registered Email Address! 
            </p>
            </div>
        </message-modal>
        <message-modal :modal-active="isPayoutAddedModal" :toggle-modal="onPayoutAddedModal" title="Your Payout">
            <div>
            <p class="mb-2.5 font-semibold text-heading__color text-center">
                Success <br/>
                Your payout has been added!
            </p>
            </div>
        </message-modal>
        <message-modal :modal-active="isCardAddedModal" :toggle-modal="onCardAddedModal" title="Your Card">
            <div>
            <p class="mb-2.5 font-semibold text-heading__color text-center">
                Success <br/>
                Your card has been added!
            </p>
            </div>
        </message-modal>
        <span id="patchLatng" @click="patchLatng()"></span>
        <nominate-maker-modal @handle-close-modal="openNominateMakerModal" :modal-active="isOpenNominateMakerModal"  :toggle-modal="openNominateMakerModal" />

        
</template>

<script setup>
import bannerSer01 from "@/assets/banner-ser/banner-ser-01.svg"

import callusser_starSolid from "@/assets/call-us-ser/star-solid.svg";
import callusser_phoneFill from "@/assets/call-us-ser/bi_phone-fill.svg";
import callusser_bxsMap from "@/assets/call-us-ser/bxs_map.svg";
import callusser_ionHappy from "@/assets/call-us-ser/ion_happy.svg";
import googleApp from "@/assets/header/google-app.svg"
import appStore from "@/assets/header/app-store.svg"
import globeImage from "@/assets/globe.png"
import footerCallUs01 from "@/assets/phone.png"

import HeroSlider from "@/components/presentational/home/hero-slider";
import AppShowcase from "@/components/presentational/home/app-showcase";
import CultureSlider from "@/components/presentational/home/culture-slider";
import SolutionForCreator from "@/components/presentational/home/solution-for-creator";

import EventsList from "@/components/presentational/home/events-list";
import {onMounted, ref, toRef, watch, watchEffect, reactive,onBeforeMount, defineAsyncComponent} from "vue";
import useUrlQuery from "@/composables/use-url-query";
import useToaster from "@/composables/use-toaster";
import {ROUTES} from "@/utils/constants/routes";
import {EVENTS_LIST} from "@/utils/constants/events";
import useUserService from "@/services/user.service";
import TokenService from "@/services/token.service";
import { ROLES } from "@/utils/constants";
import {useRouter, useRoute} from "vue-router"
import ApiClient from "@/methods/apiclient";
import tokenService from "@/services/token.service";
import { createSeoFriendlyUrl } from "@/utils/helpers";
import { MEDIA_BASEURL } from "@/utils/constants";
import OrganizerEventCountCard from "@/components/common/card/organizer-event-count-card";
import { Carousel, Slide , Navigation } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'
import PrivateEventFooter from"@/views/private-event-footer.view.vue"
import testimonial from "@/components/presentational/home/testimonial.vue";

const MessageModal = defineAsyncComponent(() => import("@/components/common/modal/message-modal"));
const NominateMakerModal = defineAsyncComponent(() => import("@/components/presentational/events/modals/nominate_maker_modal.vue"));

const router = useRouter()
const stripeResponse = useUrlQuery('payment-response')
const stripeAction = useUrlQuery('action')
const notInitial = ref(true)
const payoutResponse = useUrlQuery('payout-response')
const userData = TokenService.getUser()
const {useFetchUserService} = useUserService()
const isSuccessMessageModal = ref(false)
const isPayoutAddedModal = ref(false)
const isCardAddedModal = ref(false)
const aplace = ref(localStorage.getItem('aplace') ? localStorage.getItem('aplace') : '');
const refUserId = ref(!!userData?._id ? userData?._id : null)
const ComneteEvents=ref([])
const user=ref(tokenService.getUser())
const nearbyEventHide = ref(false);
const isFeatureEventSectionVisible = ref(true);
const culturalSpotlights = ref([])
const filters = reactive({
  pageName: 'Culturalspotlight',
  search: ''
})
const makers = ref([])
const makerFilters = reactive({
  pageName: 'Maker',
  search: ''
})
const onSuccessMessageModal = () => {
  isSuccessMessageModal.value = !isSuccessMessageModal.value
}
const culturalCarousel = ref(null);

function scrollLeft() {
  culturalCarousel.value?.prev?.();
}

function scrollRight() {
  culturalCarousel.value?.next?.();
}
const onPayoutAddedModal = () => {
  isPayoutAddedModal.value = !isPayoutAddedModal.value
}

const onCardAddedModal = () => {
  isCardAddedModal.value = !isCardAddedModal.value
}


const route = useRoute()

watch(() => route.fullPath, (newPath, oldPath) => {
  if (newPath !== oldPath) {
    document.body.classList.remove('home-page');
  }
});

watch(() => {
    document.body.classList.add('home-page');
});

onMounted(()=>{

  if(stripeResponse === "success" && stripeAction == 'card'){

    refUserId.value = !!userData?._id ? userData?._id : null
    if(user.value?.role=='guest') TokenService.clearStorage()
    onCardAddedModal()
    router.push('/')
    
  }else if(stripeResponse === "success" && stripeAction == 'booking'){
    
    TokenService.removeCartData()
    refUserId.value = !!userData?._id ? userData?._id : null
    if(user.value?.role=='guest') TokenService.clearStorage()
    // onSuccessMessageModal()
    const bookedEventTitle = useUrlQuery('event')
    const bookedTotalTickets = useUrlQuery('ticket')

  
    router.push({name:ROUTES.BOOKING_SUCCESS,query:{event:bookedEventTitle,ticket:bookedTotalTickets}})
    // router.push('/')

  }else if (payoutResponse === "success"){

    refUserId.value = !!userData?._id ? userData?._id : null
    onPayoutAddedModal()
    router.push('/')
    
  }
  else if(payoutResponse === "error"){
    // router.go(-2)
    // router.push({name:ROUTES.CHECKOUT})
    useToaster('danger',"Error","Payment is not done")
  }
  else if(stripeResponse === "error"){
    // router.go(-2)
    router.push('/');
  }
  getCulturalSpotlight();
  getMakers();
  getDataOfFeaturedEventsSetting();
})

const {data: realUserData,isLoading:fetchUserLoading,isSuccess:isFetchUserSuccess} = useFetchUserService(refUserId,stripeResponse === "success" && !!refUserId.value)
watch(()=>isFetchUserSuccess.value,()=>{
  if(isFetchUserSuccess.value){
    TokenService.updateUser('firstName',realUserData.value?.firstName)
    TokenService.updateUser('lastName',realUserData.value?.lastName)
    TokenService.updateUser('bio',realUserData.value?.bio)
    TokenService.updateUser('organization',realUserData.value?.organization)
    if(userData?.role === ROLES.ORGANIZER){
      TokenService.updateUser('country',realUserData.value?.country)
      TokenService.updateUser('stripeConnectCompleted',realUserData.value?.stripeConnectCompleted)
    }
  }
})

const eventTypes = ref([]);
const cultures = ref([]);
const eventTypeList = () => {
  ApiClient.get("event-types/all", { page: 1, limit: 999999999, onlyAllowedEvents: 1 }).then((res) => {
    if (res.data) {
      eventTypes.value = res.data;
    }

  });
};
eventTypeList();


const haveSpecialEvent = ref(false);
const specialEvent = ref({});

const getSpecialEvent = () => {
  ApiClient.get("event/special", {}).then((res) => {
    if (res.data) {
        haveSpecialEvent.value = true
        specialEvent.value = res.data
    }else{
        haveSpecialEvent.value = false
        specialEvent.value = {}
    }
  });
};
getSpecialEvent();
const getCultureContents = () => {
//   loading2.value = true
  ApiClient.get('content/all', { page: 1, limit: 999999999,homePageOnly:true }).then(res => {
    
    let newarr = [];
    const elementToRemove = 'All';
    newarr = res.data.filter(item => item.culture !== elementToRemove);
    
    cultures.value = newarr
    
    // loading2.value = false
  })
}
// getCultureContents()

const getComneteEvents=()=>{
  ApiClient.get('event/event-planer/event-without-auth',{page:1,limit:3,isPublished:true}).then(res=>{
    ComneteEvents.value=res.data
  })
}
// getComneteEvents()

// const {useFetchPUFEventsService,useFetchNearbyEventsService} = useEventsService()

const longitude = ref(0)
const latitude = ref(0)
const PUFEvents=ref([])
const favEvents=ref([])
// const {data : nearbyEvents, isSuccess:nearbyEventSuccess} = useFetchNearbyEventsService({latitude, longitude})
const nearbyEventsList = ref([]);
const favEventsList = ref([]);

const eventFilterTypes = reactive({
    featured : '',
    popular : '',
    favourites : '',
    nearby : '',
    upcoming:'',
    worldwidePopular:''
});



const patchLatng=()=>{
  latitude.value=Number(localStorage.getItem('alat')||0)
  longitude.value=Number(localStorage.getItem('alng')||0)
  console.log("latitude home",latitude.value);
  console.log("longitude home",longitude.value);
//   getData()
}
patchLatng()

const popularEventDetails = reactive({
    isLocationEvent:false,
    popularEvents:[],
    initialResponse:true
})
// const getPopularEvents = (byLocationDefault=true,dateFilter = '') => {

//     var params = {
//         limit: 4,
//         page: 1,
//         isFeatured: false,
//     };

//     if(dateFilter != ''){
//         params.dateFilter = dateFilter;
//     }

//     console.log(params,'params')

//     // if(latitude.value != 0 && longitude.value != 0 && byLocationDefault){
//     //     ApiClient.get('event/featured-popular', {...params,latitude:latitude.value,longitude:longitude.value }).then(res => {
//     //         if(res.data && res.data.length > 0){
//     //             // Location Event
                
//     //             popularEventDetails.isLocationEvent = true;
//     //             popularEventDetails.popularEvents = res.data

//     //         }else{

//     //             // Without Location //
//     //             getPopularEvents(false,dateFilter);

//     //         }

//     //     });
//     // }else{
//         ApiClient.get('event/featured-popular', {...params }).then(res => {
//             if(res.data && res.data.length > 0){
//                 popularEventDetails.isLocationEvent = false;
//                 popularEventDetails.popularEvents = res.data
//             }else{
//                     if(dateFilter == ''){
//                         popularEventDetails.initialResponse = false;
//                     }
//             }
//         })
//     // }

    

// }
// getPopularEvents();

const worldwidePopularEvents = ref([])
const getWorldWidePopularEvents = () => {
    var params = {
        limit: 8,
        page: 1,
        isFeatured: false,
    };

    ApiClient.get('event/featured-popular', {...params }).then(res => {
        if(res.data && res.data.length > 0){
            // Location Event
            
            worldwidePopularEvents.value = res.data

        }else{

            worldwidePopularEvents.value = []

        }

    });

}
getWorldWidePopularEvents();

const featuredEvents = ref([]);
const getFeaturedEvents = (dateFilter = '') => {
    var params = {
        limit: 4,
        page: 1,
        latitude:latitude.value,
        longitude:longitude.value
    };

    params.isFeatured = true;

    if(dateFilter != ''){
        params.dateFilter = dateFilter;
    }

    ApiClient.get('event/featured-popular', params).then(res => {
        if(res.data){
            featuredEvents.value = res.data
        }else{
            featuredEvents.value = [];
        }
    })
}
getFeaturedEvents();


const upcomingEventDetails = reactive({
    isLocationEvent:false,
    upcomingEvents:[],
    initialResponse:true
});

const getUpcomingEvents = (byLocationDefault=true,dateFilter='') => {
    var params = {
        limit: 4,
        page: 1,
        
    };

    if(dateFilter != ''){
        params.dateFilter = dateFilter;
    }

    // if(latitude.value != 0 && longitude.value != 0 && byLocationDefault){
    //     ApiClient.get('event/upcoming-events', {...params,latitude:latitude.value,longitude:longitude.value}).then(res => {
    //         if(res.data && res.data.upcomingEvents && res.data.upcomingEvents.length > 0){
    //             upcomingEventDetails.isLocationEvent = true
    //             upcomingEventDetails.upcomingEvents = res.data.upcomingEvents
    //             upcomingEventDetails.initialResponse = true;

    //         }else{
    //             getUpcomingEvents(false,dateFilter);
    //         }
    //     })
    // }else{
            ApiClient.get('event/upcoming-events', {...params}).then(res => {
                if(res.data  && res.data.upcomingEvents && res.data.upcomingEvents.length > 0){
                    upcomingEventDetails.isLocationEvent = false
                    upcomingEventDetails.upcomingEvents = res.data.upcomingEvents
                    upcomingEventDetails.initialResponse = true;
                }else{
                    upcomingEventDetails.isLocationEvent = false
                    upcomingEventDetails.upcomingEvents = [];
                    if(dateFilter == ''){
                        upcomingEventDetails.initialResponse = false;
                    }
                }
            })
    // }
    
}
getUpcomingEvents()


const eventCities = ref([]);
const getCitiesAccordingEvents = () =>{
    eventCities.value = [];
    var params = {
        limit: 4,
        page: 1,
    };

    ApiClient.get('event/cities', {...params}).then(async res => {
        if(res.data && res.data.length > 0){
            const updatedCities = await Promise.all(
                res.data.map(async (details) => {
                    const imageUrl = await getImageByCityName(details.city);
                    return { city: details.city, imageUrl };
                })
            );
            eventCities.value = updatedCities;
        }
    })
}
getCitiesAccordingEvents();

const organizerDetails = reactive({
    isLocationOrganizer:false,
    organizers:[]
})
const getOrganizers = (byLocationDefault=true) => {

    var params = {
        limit: 6,
        page: 1,
        type:'organizers'
    };

    if(latitude.value != 0 && longitude.value != 0 && byLocationDefault){
        ApiClient.post('user/organizers', {...params,isPopular:false,latitude:latitude.value,longitude:longitude.value}).then(res => {
            if(res.data && res.data.length > 0){

                organizerDetails.isLocationOrganizer = true;
                organizerDetails.organizers = res.data;

            }else{
                getOrganizers(false);
            }

        })
    }else{
            ApiClient.post('user/organizers', {...params,isPopular:true,latitude:0,longitude:0}).then(res => {
                if(res.data){
                    organizerDetails.isLocationOrganizer = false;
                    organizerDetails.organizers = res.data;
                }else{
                    organizerDetails.isLocationOrganizer = false;
                    organizerDetails.organizers = [];
                }
            })
    }
    
}
//getOrganizers();

const organizationDetails = reactive({
    isLocationOrganization:false,
    organizations:[]
})
const getOrganization = (byLocationDefault=true) => {

    var params = {
        limit: 6,
        page: 1,
        type:'organizations'
    };

    // if(latitude.value != 0 && longitude.value != 0 && byLocationDefault){
    //     ApiClient.post('user/organizers', {...params,isPopular:false,latitude:latitude.value,longitude:longitude.value}).then(res => {
    //         if(res.data && res.data.length > 0){

    //             organizationDetails.isLocationOrganization = true;
    //             organizationDetails.organizations = res.data;

    //         }else{
    //             getOrganization(false);
    //         }

    //     })
    // }else{
            ApiClient.post('user/organizers', {...params,isPopular:true,latitude:0,longitude:0}).then(res => {
                if(res.data){
                    organizationDetails.isLocationOrganization = false;
                    organizationDetails.organizations = res.data;
                }else{
                    organizationDetails.isLocationOrganization = false;
                    organizationDetails.organizations = [];
                }
            })
    // }
    
}
getOrganization();


const handleFilterTypeChange = (data) => {
    eventFilterTypes[data.eventType] = data.filterType;

 

    if(data.eventType == EVENTS_LIST.FEATURED){
        
        getFeaturedEvents(data.filterType);

    }else if(data.eventType == EVENTS_LIST.POPULAR){
        getPopularEvents(true,data.filterType);

    }else if(data.eventType == EVENTS_LIST.NEARBY){
        
    }else if(data.eventType == EVENTS_LIST.UPCOMING){
        getUpcomingEvents(true,data.filterType);
    }else if(data.eventType == EVENTS_LIST.FAVOURITES){
       
    }
}


const favoriteEvents=()=>{
  if(user.value && userData?.role=='Seeker')
  ApiClient.get('follow/events',{page:1,limit:4,userId:user.value._id}).then(res=>{
    if(res.data){
      favEvents.value=res.data
      favEventsList.value = res.data
    }
  })
}

const goToEventDetails = (slug) =>{
    location.href='/event/'+slug
}

const eventImg = (img) => {
    let value = `${MEDIA_BASEURL}${img}`
    if (img == 'event-placeholder.png') value = '/event-placeholder.png'
    return value
}

const getImageByCityName = async (cityName) => {
  try {
    const url = `https://en.wikipedia.org/w/api.php?action=query&titles=${cityName}&prop=pageimages&format=json&pithumbsize=500&origin=*`;
    const response = await fetch(url);
    const data = await response.json();
    const pages = data.query.pages;
    const page = Object.values(pages)[0];
    
    if (page && page.thumbnail && page.thumbnail.source) {
      return page.thumbnail.source;
    } else {
      return globeImage;
    }
  } catch (error) {
    return globeImage;
  }
};

const getCulturalSpotlight = (p = {}) => {
    let filter = { ...filters, ...p }
    ApiClient.get('cultural-spotlight/page-name', filter).then(res => {
        if (res.data.media) {
            // FIRST filter only published items, THEN map and sort
            let publishedItems = res.data.media
                .filter(el => el?.published === true) // Filter published FIRST
                .sort((a, b) => (a.order || 0) - (b.order || 0)) // Sort by admin order
                .map((el, index) => { // Then map with new indices
                    return {
                        title: el?.title,
                        subTitle: el?.subTitle,
                        description: el?.description,
                        order: el.order,
                        banner: el?.banner,
                        _id: el?._id,
                        id: index, // This will be 0, 1, 2... based on published items only
                        isExist: true,
                        published: el?.published
                    }
                })
            
            culturalSpotlights.value = publishedItems
            console.log(`Showing ${publishedItems.length} published spotlights out of ${res.data.media.length} total`)
        } else {
            culturalSpotlights.value = []
        }
    }, err => {
        console.log("Error while fetching data");
        culturalSpotlights.value = []
    })
}

const getMakers = (p = {}) => {
    let filter = { ...makerFilters, ...p }
    ApiClient.get('maker/page-name', filter).then(res => {
        if (res.data.media) {
            // Get only the last 3 entries
            let arr = res.data.media
            .filter(el => el?.published === true) // Filter published FIRST
            .sort((a, b) => (a.order || 0) - (b.order || 0)) // Sort by admin order
            .map((el, index) => {
                return {
                    title: el?.title,
                    subTitle: el?.subTitle,
                    description: el?.description,
                    order: el.order,
                    banner: el?.banner,
                    _id: el?._id,
                    id: index,
                    isExist: true,
                };
            });
            makers.value = arr;
        } else {
        makers.value = []
        }
    }, err => {
        console.log("Error while fetching data");
    })
}
function truncateDescription(text) {
    if (typeof text !== 'string') return '';
    const words = text.split(' ');
    return words.length > 10 ? words.slice(0, 10).join(' ') + '...' : text;
}

// Show 3 slides by default
const itemsToShow = 3

// Responsive breakpoints
const breakpoints = {
  1024: {
    itemsToShow: 3,
    itemsToScroll: 1,
  },
  768: {
    itemsToShow: 2,
    itemsToScroll: 1,
  },
  0: {
    itemsToShow: 1,
    itemsToScroll: 1,
  },
}
const featured = ref(null);

function handleScroll(refName) {
  const refMap = {
    featured
  };

  const target = refMap[refName];
  let element = null;
  if (target?.value?.$el) {
    element = target.value.$el;
  } else if (target?.value?.scrollIntoView) {
    element = target.value;
  }

  if (element) {
    // Scroll into view first
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // Then apply offset (after slight delay to ensure scroll is completed)
    setTimeout(() => {
      const headerOffset = 95; // 👈 Adjust this value to your header height
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }, 300); // Delay may be tuned based on scrollIntoView animation duration
  }  else {
    console.warn(`No scrollable element found for ref: ${refName}`);
  }
}

const getDataOfFeaturedEventsSetting = async () => {
  try {
    const response = await ApiClient.get('module-settings/get-feature-event');
    isFeatureEventSectionVisible.value = response.data.featuredEventsEnabled;
    console.log('Featured Events Setting:', isFeatureEventSectionVisible.value);
  } catch (error) {
    console.error(error);
  }
};

const trackShareStory = () => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'share_story_click');
  }
};
</script>
<script>
export default {};

const detail = (title, id, name) => {
    if(name ==='maker') {
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'maker_card_click', { maker_title: title, maker_id: id });
        }
        location.href = `/makers/${id}/${createSeoFriendlyUrl(title)}`;
    } else {
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'cultural_spotlight_click', { spotlight_title: title, spotlight_id: id });
        }
        location.href = `/cultural-spotlights/${id}/${createSeoFriendlyUrl(title)}`;
    }
}

const isOpenNominateMakerModal = ref(false)
const openNominateMakerModal = () => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'nominate_maker_click');
  }
  window.scrollTo(0,0)
  isOpenNominateMakerModal.value = !isOpenNominateMakerModal.value;
  document.getElementById("body").classList.add('modalOpened')
}
</script>
<style>
    .card {
        border-radius: 8px;
        position: relative;
    }

    .card-img {
        width: 100%;
        height: 250px;
        object-fit: cover;
        display: block;
    }

    .card-overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 1rem;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent);
        /* color: white; */
    }


    body {
      font-family: sans-serif;
      background-color: #f5f7fa;
      margin: 0;
      padding: 20px;
    }

    .slider-container {
      overflow-x: auto;
      white-space: nowrap;
      scroll-behavior: smooth;
      padding-bottom: 10px;
    }

    .card {
      display: inline-block;
      width: 400px;
      /* margin-right: 20px; */
      overflow: hidden;
      background-color: #000;
      color: white;
      position: relative;
    }

    .card img {
      width: 100%;
      height: 300px;
      object-fit: cover;
      display: block;
    }

    .card-title {
      font-weight: bold;
      font-size: 1.2rem;
      margin-bottom: 5px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .card-title {
    font-weight: bold;
    font-size: 1.2rem;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    max-width: 400px;
    }

    /* Scrollbar Styling (Optional) */
    .slider-container::-webkit-scrollbar {
      height: 8px;
    }

    .slider-container::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 10px;
    }

    .slider-container::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
    .image-section img {
        width: 310px;
        height: 350px;
        object-fit: cover;
    }
    .culture-section h3.card-title {
    color: #14163C;
    text-align:left;
}
    .culture-section p.card-text {
    color: #14163C8A;
    line-height:24px;
    text-align:left;
}
.culture-section .card{
    background:transparent;
}
/* Reduce button size and move closer to the cards */
.carousel__prev,
.carousel__next {
    color: white !important; 
  background-color: #f04d2d;
}

.carousel__prev:hover,
.carousel__next:hover {
  background-color: #d13e23;
}

@media (max-width: 768px) {
    .carousel__prev, .carousel__next {
        transform: unset !important;
    }
    .carousel__next {
        right: -6px;
    }
    .carousel__prev {
        left: -6px;
    }
}

@media (min-width: 768px) {
    .carousel__prev {
        left: -38px;
    }
    .carousel__next {
    right: -38px;
    }
}
  </style>